import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    template: `
        @if (title) {
            <p class="mb-2 text-center text-sm font-medium text-slate-500">
                {{ title | translate }}
            </p>
        }

        <div
            class="relative mb-2 h-2.5 overflow-hidden rounded-full bg-slate-100"
        >
            <span
                class="block h-full rounded-full transition-all duration-300"
                [style.width]="progress * 100 + '%'"
                [ngClass]="{
                    'bg-slate-300': progress === null,
                    'bg-rose-500': progress !== null && progress < 0.6,
                    'bg-amber-500': 0.6 <= progress && progress < 0.9,
                    'bg-emerald-500': 0.9 <= progress,
                }"
            ></span>
        </div>

        <div class="flex items-center justify-between">
            <span class="text-lg font-bold text-slate-800">
                {{ progress * 100 | number: '1.0-0' }}%
            </span>

            @if (expectedProgress) {
                <div class="flex items-center gap-2 text-sm text-slate-500">
                    <span>
                        {{ 'translate_expected_progress' | translate }}:
                        {{ expectedProgress * 100 | number: '1.0-0' }}%
                    </span>
                    @if (difference !== 0) {
                        <span
                            class="flex items-center gap-1"
                            [ngClass]="
                                difference > 0
                                    ? 'text-rose-600'
                                    : 'text-emerald-600'
                            "
                        >
                            <i
                                class="fa-solid text-xs"
                                [ngClass]="
                                    difference > 0
                                        ? 'fa-arrow-down'
                                        : 'fa-arrow-up'
                                "
                            ></i>
                            {{ difference | mathAbs }}%
                        </span>
                    }
                </div>
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ProgressBarComponent {
    @Input() public title?: string;

    @Input() public progress!: number;

    @Input() public expectedProgress?: number;

    public get difference(): number {
        const diff =
            (this.expectedProgress || 0) * 100 - (this.progress || 0) * 100;
        return +diff.toFixed();
    }
}
